<template>
	<div class="index_body preview_box" id="top" :class="isPhone == 'true' ? 'mobile' : ''">
		<head-nav @userInfo="getUserToken"></head-nav>
		<div class="top_banner">
			<img :src="imgAllPath('banner.png')" class="banner_img" />
			<div class="btn_box">
				<img :src="imgAllPath('btn1.png')" class="banner_btn btn1" @click="clickBtn" />
				<img :src="imgAllPath('btn2.png')" class="banner_btn btn2" @click="aboutUs" />
			</div>
		</div>
		<div class="banner_box">
			<!-- 上传预览 -->
			<a id="public" name="public" class="zhanwei"></a>
			<div class="domConversionOfd_body" id="uploadBox">
				<div class="title">
					<h2>在线预览</h2>
					<p class="tip_text mt-20">支持格式：OFD、PDF、WPS、Word、Excel、PPT、TXT、多页TIFF、图片、ZIP等。</p>
					<!-- <div class="tip_text">
						需要更多格式预览请
						<a class="tip_a" @click="aboutUs()">联系我们</a>
					</div>-->
				</div>
				<div class="down-type" :class="{ active: !isShow }">
					<uploader
						ref="uploader"
						:options="options"
						:autoStart="false"
						@file-added="onFileAdded"
						@files-submitted="onSubmitted"
						class="uploader-app"
						v-if="isShow"
					>
						<uploader-unsupport></uploader-unsupport>
						<uploader-drop>
						<div
							class="uploader-btn btn-primary"
							v-if="!token"
							@click.prevent="loginBtn"
						>选择文件</div>
						<uploader-btn
							id="global-uploader-btn"
							v-else
							class="uploader-btn btn-primary"
							:attrs="attrs"
							:single="true"
							ref="uploadBtn"
						>选择文件</uploader-btn>
						<p>点击或拖拽打开文件，文件总大小不超过5M。</p>
						<p style="padding-top: 8px">仅支持单个文件上传</p>
					</uploader-drop>
					</uploader>
					<!-- 上传状态-->
					<div class="uploading_box" v-if="allUpLoadFlag">
						<!--上传中-->
						<template v-if="allUpLoadFlag == 1">
							<img :src="myFileType(fileData.name, 1)" alt class="uploading_img" />
							<div id="loading1">
								<div class="demo1"></div>
								<div class="demo1"></div>
								<div class="demo1"></div>
							</div>
							<p>文件上传中</p>
						</template>
						<template v-else>
							<!-- 是压缩包且需要解压 -->
							<div
								class="fail_box"
								v-if="['zip', 'rar'].includes(fileConversionNeedDTO.fileType) && (pressFailed == 1 || pressFailed == 2)"
							>
								<div class="fail_top">
									<img :src="myFileType(fileData.name)" alt />
									<a class="fail_name" :title="fileData.name">{{ fileData.name | limitFileName(15) }}</a>
								</div>
								<div class="cs_button_box" style="justify-content: center">
									<el-button class="agin_btn mr-24" @click="showDialog = true">解压文件</el-button>
								</div>
							</div>
							<!-- 非压缩包或不需要密码的压缩包 -->
							<template v-else>
								<!-- 失败  -->
								<div class="fail_box" v-if="allUpLoadFlag == 2">
									<div class="fail_top">
										<img :src="myFileType(fileData.name)" />
										<a class="fail_name" :title="fileData.name">{{ fileData.name | limitFileName(15) }}</a>
									</div>
									<!--解压失败 -->
									<div v-if="pressFailed == 3" class="file_press">
										<img :src="imgAllPath('file.png')" alt />
										<span>解压失败！</span>
									</div>
									<div class="cs_button_box" v-else>
										<span class="span">上传失败</span>
										<el-button class="agin_btn" @click="onFileAdded(fileData, 'isReUpload')">重试</el-button>
									</div>
								</div>
								<!-- 成功  -->
								<div class="fail_box" v-show="allUpLoadFlag == 3">
									<div class="fail_top">
										<img :src="myFileType(fileData.name)" alt />
										<a class="fail_name" :title="fileData.name">{{ fileData.name | limitFileName(15) }}</a>
									</div>
									<div class="cs_button_box">
										<el-button class="agin_btn" @click="goRead()">立即预览</el-button>
										<!-- 二维码 -->
										<el-popover
											placement="bottom"
											width="182"
											trigger="hover"
											popper-class="qrcode_box"
											ref="popover"
										>
											<div class="qrcode_body">
												<p class="name">手机扫描二维码预览文件</p>
												<div class="qrcode_main">
													<div id="qrcode" class="qrcode" ref="qrcodeDom"></div>
													<!-- 遮造层 -->
													<div class="qrcode_cover"></div>
												</div>
												<a class="sname" :title="fileData.name">{{ fileData.name | limitFileName(10) }}</a>
												<p class="size">文档大小：{{ fileData.fileSize }}</p>
											</div>
										</el-popover>
										<div class="icon_box ml-24" v-popover:popover>
											<img :src="imgAllPath('icon2.png')" alt />
										</div>
										<div class="icon_box" style="cursor: pointer;" @click="share()">
											<img :src="imgAllPath('icon1.png')" alt />
										</div>
									</div>
								</div>
							</template>
							<div v-if="!isShow" class="select_box">
								<el-button class="agin_btn mr-30" @click="selectFile" type="primary">选择文件</el-button>
							</div>
						</template>
					</div>
				</div>
			</div>
			<!-- 支持海量格式 -->
			<div class="format_desc">
				<h2>支持海量格式</h2>
				<div class="content_box">
					<p class="content_title">免费体验</p>
					<div class="content">
						<div class="desc" v-for="(item) in formatDesc" :key="item.title">
							<img :src="imgAllPath(item.img)" alt />
							<p class="format_title">{{ item.title }}</p>
							<p class="format_span">{{ item.desc }}</p>
						</div>
					</div>
					<!--更多格式 -->
					<div class="more_box">
						<p class="more_title">更多格式：</p>
						<div class="more">
							<div v-for="(item) in moreFormatDesc" :key="item.title" class="item">
								<img :src="imgAllPath(item.img)" alt />
								<p class="more_span">{{ item.desc }}</p>
							</div>
						</div>
					</div>
					<!-- 所有格式 -->
					<div class="detail_box" v-show="showText">
						XPS、CEB、SEP、S2、S72、S92、PS2、S10、DOT、WPT、DOTX、PPS、PPSX、DOCM、DOTM、XLT、ET、ETT、XLTX、CSV、XLSM、
						XLTM、XLSB、POT、POTX、PPTM...
						<span @click="showText = !showText">展开</span>
					</div>
					<div class="detail_box" v-show="!showText">
						XPS、CEB、SEP、S2、S72、S92、PS2、S10、DOT、WPT、DOTX、PPS、PPSX、DOCM、DOTM、XLT、ET、ETT、XLTX、CSV、XLSM、XLTM、XLSB、POT、POTX、PPTM、PPSM、UOP、UOF、UOT、UOS、DPS、DPT、GIF、SVG、PSD、VSD、VSDX、CDR、TAR、JAR、GZIP、SEVEN_ZIP、HTM、HTML、XML、MHT、MHTML、CSS、C、CPP、JAVA、JS、H、ASM、S、ASP、BAT、BAS、PRG、CMD、LOG、EPUB、RTF、INI、INF、MD、LRC、DBF。
						<span @click="showText = !showText">收起</span>
					</div>
					<div class="tip_text">
						更多格式预览，请
						<a class="tip_a" @click="aboutUs()">联系我们</a>
					</div>
				</div>
			</div>
			<!-- 产品优势 -->
			<div class="advantage_desc">
				<h2>产品优势</h2>
				<div class="content_box">
					<div class="content" v-for="(item, index) in advantageDesc" :key="index">
						<img :src="imgAllPath(item.img)" class="content_img" />
						<p class="content_t">{{ item.title }}</p>
						<p class="content_d">{{ item.text }}</p>
					</div>
				</div>
			</div>
			<!-- 产品功能 -->
			<!-- <div class="product_box">
				<h2>产品功能</h2>
				<img :src="imgAllPath('banner2.png')" class="product_img" />
				<p class="product_p">OFD及常用文件格式安全预览</p>
			</div>-->
			<div class="deployment_box">
				<img :src="imgAllPath('banner5.png')" alt class="left" />
				<div class="right">
					<h2>私有云部署</h2>
					<p>将数科OFD在线预览服务私有化部署到本地服务器，提供本地预览及更多定制化功能。可支持更多平台及格式定制，采用多线程技术、集群部署方式，支持高并发和负载均衡。本地部署确保文档安全不泄露，有效规避外来病毒文档的侵害，进一步保障文档和系统安全。</p>
					<div class="ty_btn" @click="aboutUs">立即咨询</div>
				</div>
			</div>
			<!-- footbanner -->
			<div class="foot_banner">
				<img :src="imgAllPath('banner4.png')" alt class="left" />
				<div class="right">
					<p class="right_t">支持全环境使用</p>
					<p class="right_p">适用于所有计算机，包括Mac、Windows及Linux。</p>
					<p class="right_p">在线兼容主流浏览器，如：火狐浏览器、Chrome浏览器、Safari浏览器、360浏览器、Microsoft Edge浏览器、IE10及以上版本等。</p>
				</div>
			</div>
		</div>
		<customer-service :callUs="callUs" @callUs="getCallUs"></customer-service>
		<!-- footer -->
		<footer-nav></footer-nav>
		<!-- 解压弹框 -->
		<pressDialog
			:modalShow.sync="showDialog"
			@getResult="getResult"
			@changePwd="changePwd"
			:status="showErrTip"
			@closeModal="closeModal"
			:loading="loading"
		/>
		<!-- 分享弹框 -->
		<share
			:showShare="showShare"
			:shareUrl="shareUrl"
			status="readPage"
			:fileInfo="fileInfo"
			@closeBtn="closeBtn"
		></share>
	</div>
</template>
<script>
import headNav from "@comm/components/document-conversion/headerPage";
import footerNav from "@comm/components/document-conversion/footerPage";
import customerService from "@comm/components/document-conversion/customerService";
import pressDialog from "@comm/components/document-conversion/pressDialog";
import share from "@comm/components/document-conversion/shareBox";
import { queryFileUploadInfo, uploadBurstFile, pubserviceUpload, eventStay, eventUpload,eventCount } from "@comm/api/document-conversion";
import { ACCEPT_CONFIG } from "@comm/utils/acceptFileType.js";
import SparkMD5 from "spark-md5";
import QRCode from "qrcodejs2";
import common from "@comm/utils/common";
import { getToken, getUserInfo } from "@comm/utils/auth";
import { getfilesize } from "@comm/utils/tools";
export default {
				metaInfo: {
    title: '数科OFD在线云预览，支持OFD文档及多种格式在线预览，安全高效',
    meta: [
      {
        name: 'keywords',
        content: 'OFD、在线预览文档、在线云文档、OFD文档查看、PDF查看'
      },
      {
        name: 'description',
        content: '数科OFD在线云预览平台，支持OFD、PDF等海量格式跨平台在线预览，无需下载即点即看；文档分享可精细设置文档权限，安全高效纵览无界。'
      }
    ]
  },
	components: { headNav, footerNav, customerService, pressDialog, share },
	data() {
		this.advantageDesc = [
			{
				img: "one.png",
				title: "无需下载 即点即看",
				text: "支持海量格式多端在线文档预览，用户无需下载任何客户端插件，快速轻量浏览文档。"
			},
			{
				img: "two.png",
				title: "高速加载 原版呈现",
				text: "多线程高速加载优化，文档自动根据格式调整页面，以原版格式布局呈现最佳浏览体验。"
			},
			{
				img: "three.png",
				title: "文档安全 精准防护",
				text: "除用户自行分享文档外，全面阻断任何渠道访问您的文档。支持对文档复制、下载、打印、有效时间等权限进行安全控制，严格保护文档隐私安全。"
			},
			{
				img: "four.png",
				title: "海量用户  智慧之选",
				text: "数科OFD在线云预览系统服务WPS Office 4亿月活用户，满足海量用户使用需求，提供稳定方便的多格式文档在线预览支持。"
			}
		];
		this.formatDesc = [
			{
				img: 'doc.png',
				title: 'OFD格式',
				desc: 'OFD'
			},
			{
				img: 'pdf.png',
				title: 'PDF格式',
				desc: 'PDF'
			},
			{
				img: 'wps.png',
				title: 'WPS格式',
				desc: 'WPS'
			},
			{
				img: 'word.png',
				title: '文字格式',
				desc: 'DOC、DOCX'
			},
			{
				img: 'xlx.png',
				title: '表格格式',
				desc: 'XSL、XSLX'
			},
			{
				img: 'ppt.png',
				title: '演示格式',
				desc: 'PPT、PPTX'
			},
			{
				img: 'txt.png',
				title: 'TXT格式',
				desc: 'TXT'
			},
			{
				img: 'img.png',
				title: '图片格式',
				desc: 'JPG、PNG、BMP'
			},
			{
				img: 'tiff.png',
				title: '多页TIFF',
				desc: 'TIF、TIFF'
			},
			{
				img: 'zip.png',
				title: '压缩包格式',
				desc: 'ZIP、RAR'
			}
		]
		this.moreFormatDesc = [
			{
				img: 'psd.png',
				desc: 'PSD'
			},
			{
				img: 'cdr.png',
				desc: 'CDR'
			},
			{
				img: 'html.png',
				desc: 'HTML'
			},
			{
				img: 'css.png',
				desc: 'CSS'
			},
			{
				img: 'dwg.png',
				desc: 'DWG'
			}
		]
		return {
			showText: true,
			callUs: false,
			isShow: true,
			isPhone: "",
			options: {
				target: "invoice-info/upload",
				chunkSize: "2048000",
				fileParameterName: "upfile",
				maxChunkRetries: 1,
				testChunks: false,
				allowDuplicateUploads: true,
				headers: {
					// Authorization: getToken(),
				},
				query() { }
			},
			attrs: {
				accept: ACCEPT_CONFIG.getOnlineReadType()
			},
			// 文件
			fileData: {},
			fileInfo: {},
			fileConversionNeedDTO: {}, //返回的文档
			allUpLoadFlag: null, //上传状态： 1上传中 2上传失败 3上传成功
			// 解压
			showDialog: false,
			pressFailed: null, //解压失败 1 需要密码 2密码错误 3不需要密码的解压失败 4成功
			showErrTip: false,
			loading: false,
			//分享
			shareUrl: "",
			showShare: false,
			token: null,
			suwellUserId:'',
			currentTime: '',
			uploadcurrentTime: '',
			userInfo:null
		};
	},
	created() {
		document.title = "在线预览";
		this.token = getToken()
		this.currentTime = new Date().getTime();
		this.userInfo = getUserInfo() ? JSON.parse(getUserInfo()) : null;
		this.suwellUserId=this.userInfo?this.userInfo.suwellUserId:''
		this.$nextTick(() => {
			this.toLocal();
		});
	},
	mounted() {
		document.body.ondrop = function(event){
			event.preventDefault();
			event.stopPropagation();
		}
	},
	computed: {
		imgAllPath() {
			return function (img) {
				return require("@comm/images/document-conversion/onlinePreview/" + img);
			};
		},
		//根据文件类型展示对应图片
		myFileType() {
			return function (name, type = "") {
				//type 1上传中
				if (!name) return;
				let fileArr = name.split(".");
				let fileFormat = fileArr[fileArr.length - 1];
				let allUpLoadFlag = this.allUpLoadFlag;
				let pressFailed = this.pressFailed;
				let imgName = null;
				let typeObj = {
					"jpg,png,bmp": ["img.png", "img_1.png"],
					"xls,xlsx": ["xlx.png", "xlx_1.png"],
					"ppt,pptx": ["ppt.png", "ppt_1.png"],
					"doc,docx": ["word.png", "word_1.png"],
					'txt': ["txt.png", "txt_1.png"],
					"zip,rar": ["zip.png", "zip_1.png"],
					'wps': ["wps.png", "wps_1.png"],
					'pdf': ["pdf.png", "pdf_1.png"],
					"tiff,tif": ["tiff.png", "tiff_1.png"],
					'ofd': ["doc.png", "doc_1.png"]
				};
				for (const key in typeObj) {
					if (key.toLowerCase().indexOf(fileFormat.toLowerCase()) !== -1) {
						let index = allUpLoadFlag == 3 || type || (pressFailed && pressFailed !== 3) ? 0 : 1;
						//上传成功 || 上传中 || 解压状态为 需要密码、密码错误、成功取成功图
						imgName = typeObj[key][index];
					}
				}
				if (imgName) {
					return require("@comm/images/document-conversion/onlinePreview/" + imgName);
				}
			};
		}
	},
	destroyed() {
		localStorage.setItem("toId", "");
	},
	methods: {
		toLocal() {
			//查找存储的锚点id
			let Id = localStorage.getItem("toId");
			let toElement = document.getElementById(Id);
			//锚点存在跳转
			if (Id) {
				toElement.scrollIntoView();
			}
		},
		getUserToken(data){
			this.token=data.token
			this.suwellUserId=data.suwellUserId
		},
		confirm(text, type) {
			this.$confirm(text, "", {
				confirmButtonText: "确定",
				showCancelButton: false,
				type: type,
			}).then(() => {
				return;
			});
		},
		clickBtn() {
			let toElement = document.getElementById("uploadBox");
			//锚点存在跳转
			toElement.scrollIntoView();
		},
		confirm(text, type) {
			this.$confirm(text, "", {
				confirmButtonText: "确定",
				showCancelButton: false,
				type: type
			}).then(() => {
				return;
			});
		},
		loginBtn() {
			let path = this.$route.path;
			window.open(
				`https://openapi.wps.cn/oauthapi/v2/authorize?response_type=code&appid=AK20211015RYLLFO&autologin=false&redirect_uri=${common.readCodeUrl}${path}&scope=user_info&state=STATE`,
				"_self"
			);
		},
		//文件校验
		onFileAdded(file, type = "") {
			let lastTime = new Date().getTime();
			let duration = lastTime - this.currentTime
			eventStay({
				eventId: 3001,
				userId: this.suwellUserId,
				duration
			}).then((res) => {

			})
			if (!file) return;
			//重试
			if (type == "isReUpload") {
				this.startUpload(this.fileData);
			}
		},
		// 上传
		onSubmitted(file) {
			// ie空校验
			if (file.length <= 0) {
				// this.confirm("添加失败，文件大小为空！", "error");
				return;
			}
			// 单文件
			if (file.length > 1) {
				this.confirm("该功能仅支持单文件操作", "warning");
				return;
			}
			let fileData = file[0]
			// 格式校验
			let typeArr = this.attrs.accept.join(",");
			let index = fileData.name.lastIndexOf(".");
			let type = "." + fileData.name.substring(index + 1, fileData.name.length);
			if (typeArr.indexOf(type.toLowerCase()) == -1) {
				this.confirm("添加失败，文件格式不匹配！", "error");
				return;
			}
			//谷歌空校验
			if (fileData.size == 0) {
				this.confirm("添加失败，文件大小为空！", "error");
				return;
			}

			// 大小校验
			const isLt = fileData.size / 1024 / 1024 / 5 <= 1;
			if (!isLt) {
				this.confirm("您选择的文件大小超过5MB，请重新选择！", "warning");
				this.isShow = true;
				return;
			}
			this.uploadcurrentTime = new Date().getTime();
			this.getUploadData(file);
		},
		//处理文件格式
		getUploadData(fileList) {
			let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
			let fileReader = new FileReader();
			let spark = new SparkMD5.ArrayBuffer();
			fileReader.readAsArrayBuffer(blobSlice.call(fileList[0].file, 0, fileList[0].size));
			// 读取操作结束时触发
			fileReader.onload = (e) => {
				fileList[0].fileHash = this.$sha256(e.target.result);
				spark.append(e.target.result);
				this.fileData = fileList[0];
				this.startUpload(this.fileData);
			};
		},
		// 准备上传
		startUpload(fileData) {
			this.isShow = false;
			this.allUpLoadFlag = 1; //上传中。。
			this.fileData.fileSize = this.fileData.size ? getfilesize(this.fileData.size) : "0M";
			let myFormData = new FormData();
			myFormData.append("multipartFile ", fileData.file);
			myFormData.append("dictionaryId  ", 136);
			myFormData.append("type", 6);
			myFormData.append("fileName  ", fileData.name);
			myFormData.append("fileHash", fileData.fileHash);
			// 查询是否上传过
			queryFileUploadInfo({
				dictionaryId: 0,
				fileHash: fileData.fileHash,
				fileName: fileData.name
			})
				.then((res) => {
					if (!res.data.fileConversionNeedDTO) {
						//去上传
						this.apiUpLoad(myFormData);
					} else {
						//去预览
						this.fileConversionNeedDTO = res.data.fileConversionNeedDTO;
						let lastTime = new Date().getTime();
						let duration = lastTime - this.uploadcurrentTime
						eventUpload({
							eventId: 2001,
							userId: this.suwellUserId,
							duration,
							fileId:this.fileConversionNeedDTO.fileId,
							fileSize:this.fileConversionNeedDTO.fileSize,
							fileType:this.fileConversionNeedDTO.fileType,
						}).then((res) => {

						})
						
						this.getpubserviceUpload(res.data.fileConversionNeedDTO);
					}
				})
				.catch((err) => {
					this.apiUpLoad(myFormData);
				});
		},
		//上传调接口
		apiUpLoad(myFormData) {
			uploadBurstFile(myFormData)
				.then((res) => {
					if (!res.data.success) {
						this.allUpLoadFlag = 2; //上传失败
					} else {
						this.fileConversionNeedDTO = res.data.fileConversionNeedDTO;
						let lastTime = new Date().getTime();
						let duration = lastTime - this.uploadcurrentTime
						eventUpload({
							eventId: 2001,
							userId: this.suwellUserId,
							duration,
							fileId:this.fileConversionNeedDTO.fileId,
							fileSize:this.fileConversionNeedDTO.fileSize,
							fileType:this.fileConversionNeedDTO.fileType,
						}).then((res) => {

						})
						this.getpubserviceUpload(res.data.fileConversionNeedDTO);
					}
				})
				.catch((err) => {
					this.allUpLoadFlag = 2; //上传失败
				});
		},
		// 获取预览链接
		getpubserviceUpload(file, pressPwd = "", type = "") {
			pubserviceUpload({
				fileName: file.fileName,
				fileUrl: file.ossUrl,
				fileType: file.fileType,
				fileSize: this.fileData.size,
				fileId:this.fileConversionNeedDTO.fileId,
				zipPassword: pressPwd //解压密码
			})
				.then((res) => {
					let data = res.data.data;
					if (data) {
						if (type) this.$message.success("解压成功");
						// 重置状态
						this.showErrTip = false;
						this.showDialog = false;
						this.pressFailed = 4;
						this.allUpLoadFlag = 3;
						this.fileInfo = data;
						this.goRead();
						this.makeQrcode();
					} else {
						//无返回数据
						this.allUpLoadFlag = 2; //上传失败
						if (res.data.code == 5003) {
							//需要密码
							this.showDialog = true;
							this.pressFailed = 1;
						} else if (res.data.code == 5004) {
							//密码错误
							this.pressFailed = 2;
							this.showErrTip = true;
						} else if (res.data.code == 5002) {
							//解压失败
							this.showDialog = false;
							this.pressFailed = 3;
						}
					}
					this.loading = false;
				})
				.catch((err) => {
					this.pressFailed = 3;
					this.showErrTip = false;
					this.showDialog = false;
					this.allUpLoadFlag = 2; //上传失败
				});
		},
		//立即预览
		goRead() {
			this.userInfo = getUserInfo() ? JSON.parse(getUserInfo()) : null;
			let nickname = encodeURIComponent(encodeURIComponent(this.userInfo.nickname))
			const { href } = this.$router.resolve({
				path: `/r:${this.fileInfo.shortUrl}&&${nickname}`
			});
			window.open(href, "_blank");
		},
		// 生成二维码
		makeQrcode() {
			this.userInfo = getUserInfo() ? JSON.parse(getUserInfo()) : null;
			let nickname = encodeURIComponent(encodeURIComponent(this.userInfo.nickname))
			let text = `${common.readCodeUrl}/r:${this.fileInfo.shortUrl}&&${nickname}`;
			this.$nextTick(() => {
				new QRCode(this.$refs.qrcodeDom, {
					width: 142,
					height: 142,
					correctLevel: 3,
					text // 二维码地址
				});
			});
		},
		// 解压
		getResult(pressPwd) {
			this.loading = true;
			this.getpubserviceUpload(this.fileConversionNeedDTO, pressPwd, 1);
		},
		// 解压密码改变清空错误提示
		changePwd() {
			this.showErrTip = false;
		},
		closeModal() {
			this.showErrTip = false;
			this.showDialog = false;
		},
		//分享
		share() {
			this.userInfo = getUserInfo() ? JSON.parse(getUserInfo()) : null;
			let nickname = encodeURIComponent(encodeURIComponent(this.userInfo.nickname))
			this.shareUrl = `${common.readCodeUrl}/s:${this.fileInfo.shortUrl}&&${nickname}`;
			this.showShare = true;
			eventCount({
				eventId: 1001,
				userId: this.suwellUserId,
				fileId: this.fileConversionNeedDTO.fileId
			}).then((res) => {

			})
		},
		closeBtn() {
			this.showShare = false;
		},
		// 选择文件
		selectFile() {
			this.fileInfo = {};
			this.isShow = true;
			this.allUpLoadFlag = null;
			this.pressFailed = null;
		},
		// 联系我们
		aboutUs() {
			let that = this;
			this.callUs = true;
			setTimeout(function () {
				that.callUs = false;
			}, 10000);
		},
		getCallUs(data) {
			this.callUs = data;
		}
	}
};
</script>

<style lang="scss" scoped>
.preview_box {
	padding-top: 72px;
	.banner_box {
		width: 100%;
		height: 100%;
		background: url("../../comm/images/document-conversion/bj.png")
			no-repeat top / 100% auto;
		.swiper-pagination {
			position: absolute;
			bottom: 16px;
			left: 50%;
			transform: translateX(-50%);
		}
		.domConversionOfd_body .title {
			padding-bottom: 40px;
		}
	}
	.top_banner {
		width: 100%;
		height: 100%;
		position: relative;
		.banner_img {
			width: 100%;
		}
		.btn_box {
			position: absolute;
			top: 68%;
			left: 19%;
			z-index: 99;
			.banner_btn {
				width: 222px;
				height: 65px;
				border-radius: 4px;
				&:hover {
					cursor: pointer;
					box-shadow: 0px 2px 16px 4px rgba(24, 94, 129, 0.53);
					transform: translateY(-4px);
					transition: all 0.5s ease;
				}
			}
			.btn1 {
				margin-right: 32px;
			}
		}
	}
	.tip_text {
		text-align: center;
		font-size: 16px;
		color: #8b97af;
		line-height: 30px;
	}
	.tip_a {
		cursor: pointer;
		color: #14a8f0;
		padding-left: 12px;
		text-decoration: underline;
	}
	.mt-20 {
		margin-top: 11px;
	}
	.ml-24 {
		margin-left: 24px;
	}
	h2 {
		text-align: center;
		font-size: 32px;
		color: #242f44;
		line-height: 45px;
	}
	.advantage_desc {
		margin-top: 144px;
		.content_box {
			width: 1255px;
			display: flex;
			margin: 0 auto;
			margin-top: 64px;
			.content {
				width: 288px;
				height: 264px;
				margin-right: 16px;
				padding: 26px 19px;
				display: flex;
				flex-direction: column;
				align-items: center;
				&:last-child{
					margin: 0;
				}
				.content_img {
					width: 64px;
					height: 64px;
					margin-bottom: 20px;
				}
				.content_t {
					font-size: 20px;
					font-weight: 400;
					color: #36425a;
					line-height: 28px;
					margin-bottom: 8px;
				}
				.content_d {
					width: 250px;
					font-size: 14px;
					font-weight: 400;
					color: #8b97af;
					line-height: 22px;
					text-align: center;
				}
			}
			.content:hover {
				box-shadow: 0px 2px 14px 0px rgba(19, 167, 240, 0.2);
			}
		}
	}
	.product_box {
		margin-top: 144px;
		text-align: center;
		.product_img {
			width: auto;
			height: auto;
		}
		.product_p {
			font-size: 30px;
			font-weight: 500;
			color: #242f44;
			margin-top: -20px;
		}
	}
	.foot_banner {
		width: 100%;
		height: 195px;
		background: url(../../comm/images/document-conversion/onlinePreview/banner3.png)
			no-repeat;
		background-size: 100% 100%;
		display: flex;
		justify-content: center;
		padding: 10px 0;
		.left {
			width: 265px;
			height: 156px;
			margin: 0 24px 0 33px;
		}
		.right {
			padding: 54px 0 0 23px;
			position: relative;
			.right_t {
				margin-bottom: 5px;
				font-size: 30px;
				font-weight: 400;
				color: #36425a;
				line-height: 42px;
			}
			.right_p {
				font-size: 14px;
				font-weight: 400;
				color: #8b97af;
				line-height: 20px;
				padding-bottom: 1px;
			}
		}
		.right::before {
			content: "";
			background: #b7dafc;
			width: 2px;
			height: 82px;
			position: absolute;
			left: 0;
			top: 34%;
		}
	}
	.deployment_box {
		width: 1254px;
		padding-right: 54px;
		margin: 80px auto 0;
		display: flex;
		align-items: center;
		.left {
			width: auto;
			height: 429px;
			margin-right: 59px;
		}
		.right {
			width: 603px;
			h2 {
				font-size: 32px;
				font-weight: 400;
				color: #242f44;
				line-height: 45px;
				padding-bottom: 9px;
				border-bottom: 1px solid #d5d5d5;
				margin-bottom: 16px;
				text-align: left;
			}
			p {
				font-size: 16px;
				font-weight: 400;
				color: #8b97af;
				line-height: 30px;
				text-indent: 40px;
				margin-bottom: 24px;
			}
			.ty_btn {
				width: 130px;
				height: 38px;
				border-radius: 100px;
				border: 1px solid #14a8f0;
				font-size: 14px;
				text-align: center;
				font-weight: 400;
				color: #14a8f0;
				line-height: 38px;
				cursor: pointer;
				&:hover {
					background: #15b2ff;
					color: #ffffff;
				}
			}
		}
	}
	// 上传中
	.uploading_box {
		width: 100%;
		margin-top: 130px;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		.uploading_img {
			width: 64px;
			height: 64px;
		}
		.cs_button_box {
			text-align: left;
			margin-top: 32px;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			.span {
				font-size: 14px;
				color: #36425a;
				line-height: 22px;
				width: 64px;
				display: inline-block;
				text-align: center;
				margin-right: 44px;
			}
			.icon_box {
				width: 40px;
				height: 40px;
				border-radius: 2px;
				border: 1px solid #d7d9de;
				padding: 5px;
				margin-right: 8px;
				img {
					width: 28px;
					height: 28px;
				}
			}
			.icon_box:hover {
				border: 1px solid #14a8f0;
			}
		}
		.fail_box {
			.fail_top {
				display: flex;
				align-items: center;
				justify-items: center;
				line-height: 64px;
				img {
					width: 64px;
					height: 64px;
				}
				.fail_name {
					padding-left: 5px;
					font-size: 16px;
					color: #242f44;
					cursor: default;
					text-decoration: none;
				}
			}
			.file_press {
				margin-top: 27px;
				height: 16px;
				img {
					width: 16px;
					height: 16px;
					margin-right: 8px;
					vertical-align: middle;
				}
				span {
					font-size: 14px;
					color: #e02020;
					vertical-align: middle;
				}
			}
		}
	}
	.select_box {
		width: 100%;
		height: 88px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		position: absolute;
		bottom: 0;
		left: 0;
		border-top: 1px solid #f3f4f5;
		.mr-30 {
			margin-right: 30px;
		}
	}
	.format_desc {
		width: 1255px;
		margin: 0 auto;
		padding-top: 144px;
		.content_box {
			width: 100%;
			height: 636px;
			margin: 64px 0;
			background: url("../../comm/images/document-conversion/onlinePreview/format_banner.png")
				no-repeat 0 0;
			background-size: 100%;
			.content_title {
				height: 44px;
				font-size: 20px;
				position: relative;
				margin-bottom: 16px;
				font-weight: 500;
			}
			.content_title::after {
				content: "";
				width: 32px;
				height: 2px;
				background: #14a8f0;
				position: absolute;
				left: 0;
				bottom: 0;
			}
			.content {
				width: 512px;
				height: 336px;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				flex-wrap: wrap;
				.desc {
					width: 128px;
					height: 92px;
					padding: 8px 0 0 8px;
					// cursor: pointer;
					img {
						width: 24px;
						height: 24px;
						margin-bottom: 8px;
					}
					.format_title {
						font-size: 16px;
						line-height: 22px;
						color: #36425a;
					}
					.format_span {
						font-size: 14px;
						line-height: 20px;
						color: #8b97af;
					}
					&:hover {
						background: #ffffff;
						box-shadow: 0px 2px 14px 0px rgba(19, 167, 240, 0.2);
					}
				}
			}
			.more_box {
				.more_title {
					height: 22px;
					font-size: 14px;
					font-weight: 600;
					color: #36425a;
					line-height: 20px;
					margin-bottom: 8px;
				}
				.more {
					display: flex;
					align-items: center;
					justify-content: flex-start;
					flex-wrap: wrap;
				}
				.item {
					width: 48px;
					height: 48px;
					margin-right: 20px;
					padding: 4px 0;
					text-align: center;
					// cursor: pointer;
					img {
						width: 24px;
						height: 24px;
					}
					.more_span {
						font-size: 12px;
						color: #36425a;
						line-height: 20px;
					}
					&:hover {
						background: #ffffff;
						box-shadow: 0px 2px 14px 0px rgba(19, 167, 240, 0.2);
					}
				}
			}
			.detail_box {
				margin-top: 16px;
				width: 548px;
				font-size: 12px;
				color: #8b97af;
				line-height: 20px;
				span {
					color: #14a8f0;
					cursor: pointer;
					text-decoration: underline;
				}
			}
		}
		.tip_text {
			text-align: left;
			font-size: 16px;
			color: #36425a;
			margin-top: 12px;
			.tip_a {
				padding-left: 5px;
			}
		}
	}
}
.dialog_img {
	width: 16px;
	height: 16px;
	margin-bottom: 3px;
}
//二维码
.qrcode_box {
	width: 182px;
	height: 226px;
	background: #ffffff;
	box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
	.qrcode_body {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		.qrcode_main {
			width: 150px;
			height: 150px;
			border: 1px solid #e7e7e7;
			margin: 4px 0;
			position: relative;
			.qrcode {
				margin: 4px auto;
				width: 142px;
				height: 142px;
			}
			.qrcode_cover {
				width: 142px;
				height: 142px;
				position: absolute;
				top: 4px;
				left: 4px;
				background: transparent;
			}
		}
		.closed_btn {
			position: absolute;
			top: 15px;
			right: 15px;
			width: 17px;
			height: 16px;
			background: url("../../comm/images/document-conversion/zxyl/close_btn.png")
				0 0 no-repeat;
			background-size: 100%;
		}
		.name {
			font-size: 12px;
			color: #333333;
			line-height: 16px;
			margin-top: 8px;
		}
		.sname {
			font-size: 12px;
			color: #008ad9;
			line-height: 18px;
			text-decoration: none;
		}
		.size {
			font-size: 12px;
			color: #b1b1b1;
			line-height: 18px;
		}
	}
}
 .el-tabs__item {
	font-size: 20px !important;
}
 .el-tabs__item.is-active {
	color: #14a8f0 !important;
}
 .el-tabs__active-bar {
	background: #14a8f0 !important;
}
</style>


// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/onlinePreview.vue